export const MODELLI_REQUEST = "MODELLI_REQUEST";
export const ACTIVATE_REQUEST = "ACTIVATE_REQUEST";
export const MODELLI_SUCCESS = "MODELLI_SUCCESS";
export const MODELLI_ERROR = "MODELLI_ERROR";
export const MODELLI_URL = "https://dashboard.signati.it/";
//export const MODELLI_URL = "http://localhost/signati/dashboard/";